/* PAWNOVA v8 – frecce di navigazione per la galleria delle immagini prodotto */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var GAP = 12;

  var ICON =
    '<svg viewBox="0 0 10 16" fill="none" aria-hidden="true" focusable="false"><path d="M8.2 1.4 1.6 8l6.6 6.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function prefersReduced() {
    return !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function isDesktop() {
    return !!(w.matchMedia && w.matchMedia('(min-width: 750px)').matches);
  }

  function makeButton(dir, label) {
    var b = d.createElement('button');
    b.type = 'button';
    b.className = 'pn-gal-nav pn-gal-nav--' + dir + ' quick-add-hidden';
    b.setAttribute('aria-label', label);
    b.innerHTML = ICON;
    return b;
  }

  function getSlides(list) {
    return Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
  }

  function currentIndex(list, els) {
    var i;
    if (isDesktop()) {
      for (i = 0; i < els.length; i++) {
        if (els[i].classList.contains('is-active')) return i;
      }
      return 0;
    }
    var x = list.scrollLeft;
    var best = 0;
    var bestDelta = Infinity;
    for (i = 0; i < els.length; i++) {
      var delta = Math.abs(els[i].offsetLeft - x);
      if (delta < bestDelta) {
        bestDelta = delta;
        best = i;
      }
    }
    return best;
  }

  function setupGallery(gallery) {
    if (gallery.pnGalReady) return;

    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var list = viewer.querySelector('.product__media-list');
    if (!list || getSlides(list).length < 2) return;

    gallery.pnGalReady = true;
    gallery.classList.add('pn-gal');

    var prev = makeButton('prev', 'Immagine precedente');
    var next = makeButton('next', 'Immagine successiva');
    viewer.appendChild(prev);
    viewer.appendChild(next);

    var scheduled = false;

    /* Colloca le frecce nello spazio vuoto ai lati della foto,
       senza mai sovrapporle all'immagine quando c'e' spazio a sufficienza. */
    function place() {
      scheduled = false;
      if (!isDesktop()) {
        prev.style.left = '';
        next.style.right = '';
        return;
      }
      var media =
        viewer.querySelector('.product__media-item.is-active .product-media-container') ||
        viewer.querySelector('.product-media-container');
      if (!media) return;
      var v = viewer.getBoundingClientRect();
      var m = media.getBoundingClientRect();
      if (!v.width || !m.width) return;
      var size = prev.offsetWidth || 44;
      var spaceLeft = Math.max(0, Math.round(m.left - v.left));
      var spaceRight = Math.max(0, Math.round(v.right - m.right));
      prev.style.left = Math.max(0, spaceLeft - size - GAP) + 'px';
      next.style.right = Math.max(0, spaceRight - size - GAP) + 'px';
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      w.requestAnimationFrame(place);
    }

    function thumbsEl() {
      return gallery.querySelector('[id^="GalleryThumbnails"]');
    }

    function thumbButton(mediaId) {
      var thumbs = thumbsEl();
      if (!thumbs || !mediaId) return null;
      var item = thumbs.querySelector('[data-target="' + mediaId + '"]');
      return item ? item.querySelector('button') : null;
    }

    function go(direction) {
      var els = getSlides(list);
      if (els.length < 2) return;

      var target = els[(currentIndex(list, els) + direction + els.length) % els.length];
      var btn = thumbButton(target.getAttribute('data-media-id'));

      if (isDesktop() && btn) {
        btn.click();
      } else {
        els.forEach(function (el) {
          el.classList.remove('is-active');
        });
        target.classList.add('is-active');
        if (list.scrollTo) {
          list.scrollTo({ left: target.offsetLeft, behavior: prefersReduced() ? 'auto' : 'smooth' });
        } else {
          list.scrollLeft = target.offsetLeft;
        }
        var thumbs = thumbsEl();
        if (thumbs && btn) {
          Array.prototype.forEach.call(thumbs.querySelectorAll('button'), function (el) {
            el.removeAttribute('aria-current');
          });
          btn.setAttribute('aria-current', 'true');
        }
      }

      target.classList.add('pn-gal-in');
      w.setTimeout(function () {
        target.classList.remove('pn-gal-in');
      }, 450);
      w.setTimeout(schedule, 80);
    }

    prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      go(-1);
    });

    next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      go(1);
    });

    list.addEventListener('scroll', schedule, { passive: true });
    viewer.addEventListener('slideChanged', schedule);
    w.addEventListener('resize', schedule);
    w.addEventListener('load', schedule);
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(schedule).observe(viewer);
    }
    Array.prototype.forEach.call(viewer.querySelectorAll('img'), function (img) {
      img.addEventListener('load', schedule);
    });
    schedule();
  }

  function initAll(scope) {
    var root = scope || d;
    if (root.tagName === 'MEDIA-GALLERY') {
      setupGallery(root);
      return;
    }
    Array.prototype.forEach.call(root.querySelectorAll('media-gallery'), setupGallery);
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  d.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  if (typeof MutationObserver === 'function') {
    var pending = false;
    new MutationObserver(function (mutations) {
      if (pending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.tagName === 'MEDIA-GALLERY' || node.querySelector('media-gallery')) {
            pending = true;
            w.requestAnimationFrame(function () {
              pending = false;
              initAll();
            });
            return;
          }
        }
      }
    }).observe(d.documentElement, { childList: true, subtree: true });
  }
})();
